import { colorSet } from '@components/Provider';

export const stringToColor = (string: string) => {
  if (!string) return colorSet.gray000;
  let hash = 0;
  let i;

  for (i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = '#';

  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.substr(-2);
  }

  return color;
};

export const stringAvatar = (name: string) => {
  let internalName = name.replace(/ +(?= )/g, '');
  let result: any = {
    children: ''
  };

  if (!internalName) return result;

  if (internalName.split(' ').length === 1) {
    result.children = `${internalName.split(' ')[0][0]}`.toUpperCase();
  } else {
    result.children = `${internalName.split(' ')[0][0]}${
      internalName && internalName.split(' ')[1][0]
    }`.toUpperCase();
  }

  return result;
};

export const getDisplayedAvatarString = (userName: any, userEmail: any) => {
  return userName ? userName : userEmail ?? '';
};
